import React, { useEffect } from "react";
import BorgMap from "features/Map/BorgMap";
import SimpleMessage from "components/SimpleMessage";
import { restoreAuth } from "authSession";

// At import, before the first render, so a reload that already has a usable
// token goes straight to the map instead of bouncing through the sign-in.
restoreAuth();

const DashboardPage = () => {
  useEffect(() => {
    var query = new URLSearchParams(window.location.search);
    const embedPopup = query.get("embed-popup") == "true";

    if (!window.auth || embedPopup) {
      // e.g. https://login.microsoftonline.com/7f028e4f-bba0-4a85-9c82-82014607d412/oauth2/v2.0/authorize?client_id=434f864f-4fa8-48f1-9044-e4ccacadbf37&code_challenge=m2KTvkaNWcc8ROEiBUMVinkXRhZaOCHKOzmfURwV4b8&code_challenge_method=S256&redirect_uri=https%3A%2F%2Flocalhost%3A5700%2Fazure-ad-signin&response_mode=query&response_type=code&scope=openid%20email%20offline_access&state
      var loginUrl = process.env.AZURE_LOGIN_URL;

      if (embedPopup) {
        // get existing redirect_uri query string parameter from loginUrl
        var url = new URL(loginUrl);
        var redirectUri = url.searchParams.get("redirect_uri");
        // add embed-popup=true to the redirect_uri query string parameter (use URL class again)
        var newUrl = new URL(redirectUri);
        newUrl.searchParams.set("embed-popup", "true");
        var newRedirectUri = newUrl.toString();
        // update redirect_uri query string parameter in loginUrl
        url.searchParams.set("redirect_uri", newRedirectUri);
        loginUrl = url.toString();
      }

      document.location.href = loginUrl;
    }
  }, []);

  // register 'T' keypress to send GET request to '/test' on API
  useEffect(() => {
    const handler = (e) => {
      if (e.code == "KeyT") {
        fetch(
          (process.env.LOCAL_BORG_SERVER
            ? "http://localhost:5001/"
            : process.env.API_URL) + "test"
        )
          .then((response) => response.json())
          .then((data) => {
            console.log(data);
          });
      }
    };
    document.addEventListener("keydown", handler);
    return () => {
      document.removeEventListener("keydown", handler);
    };
  }, []);

  if (!window.auth) {
    return <SimpleMessage>Checking your identity</SimpleMessage>;
  }
  return <BorgMap />;
};

export default DashboardPage;
